// Template200: Bangkok - Ayutthaya (página 1). Idéntico a PageAyutthaya1.jsx. borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template200 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const titleOverlay = page?.texts?.[2]?.content;
	const llegarTitle = page?.texts?.[3]?.content;
	const p1 = page?.texts?.[4]?.content;
	const p2 = page?.texts?.[5]?.content;
	const p3 = page?.texts?.[6]?.content;
	const p4 = page?.texts?.[7]?.content;
	const watSanphetTitle = page?.texts?.[8]?.content ?? "Wat Phra Si Sanphet";
	const watSanphetBody = page?.texts?.[9]?.content;
	const watMahathatTitle = page?.texts?.[10]?.content ?? "Wat Mahathat";
	const watMahathatBody = page?.texts?.[11]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const watSanphetImage = getImageSrc("wat-sanphet");
	const watMahathatImage = getImageSrc("wat-mahathat");
	const stickerUrl = getCanvasImageUrl("sticker");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQueLlegar = Array.isArray(page?.data?.sabiasQueLlegar)
		? page.data.sabiasQueLlegar
		: [];
	const sabiasQueSanphet = Array.isArray(page?.data?.sabiasQueSanphet)
		? page.data.sabiasQueSanphet
		: [];
	const sabiasQueMahathat = Array.isArray(page?.data?.sabiasQueMahathat)
		? page.data.sabiasQueMahathat
		: [];
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const h4Amarillo = {
		margin: "0 0 8px 0",
		fontSize: "13px",
		fontWeight: 700,
		color: "#E8A838",
		textTransform: "uppercase",
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{ width: 90, position: "absolute", bottom: 60, left: 18 }}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontFamily: "'Poppins', sans-serif",
							fontSize: isSmallScreen ? 26 : 32,
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							right: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
			</Box>

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px", marginTop: "-10px" }}>
					<Box component="p" sx={p}>
						{intro}
					</Box>
				</Box>
			)}

			<Box data-block-id="text-2" sx={{ padding: "0 12px", marginBottom: 1.25 }}>
				<Box
					sx={{
						backgroundColor: "#FFF3CD",
						border: "3px solid #E8A838",
						borderRadius: "12px",
						padding: "12px 16px",
						color: "#333",
						position: "relative",
					}}
				>
					{sabiasQueLlegar.length > 0 && (
						<>
							<Box sx={{ position: "absolute", top: 0, left: "35%" }}>
								<SabiasQue
									icono={sabiasQueLlegar[0]?.icono ?? "🏛️"}
									texto={sabiasQueLlegar[0]?.texto ?? ""}
								/>
							</Box>
							{sabiasQueLlegar[1] && (
								<Box sx={{ position: "absolute", top: 0, left: "55%" }}>
									<SabiasQue
										icono={sabiasQueLlegar[1]?.icono ?? "⚔️"}
										texto={sabiasQueLlegar[1]?.texto ?? ""}
									/>
								</Box>
							)}
						</>
					)}
					{llegarTitle && (
						<Box component="h4" sx={h4Amarillo}>
							{llegarTitle}
						</Box>
					)}
					{p1 && (
						<Box
							component="p"
							sx={{ ...p, margin: "0 0 8px 0" }}
							dangerouslySetInnerHTML={{ __html: p1 }}
						/>
					)}
					{p2 && (
						<Box
							component="p"
							sx={{ ...p, margin: "0 0 8px 0" }}
							dangerouslySetInnerHTML={{ __html: p2 }}
						/>
					)}
					{p3 && (
						<Box
							component="p"
							sx={{ ...p, margin: "0 0 8px 0" }}
							dangerouslySetInnerHTML={{ __html: p3 }}
						/>
					)}
					{p4 && (
						<Box
							component="p"
							sx={{ ...p, margin: "0 0 8px 0" }}
							dangerouslySetInnerHTML={{ __html: p4 }}
						/>
					)}
				</Box>
			</Box>

			<Box
				data-block-id="text-3"
				sx={{
					display: "flex",
					gap: 2,
					padding: "0 12px",
					marginBottom: 1.75,
					position: "relative",
				}}
			>
				{sabiasQueSanphet.length > 0 && (
					<>
						<Box sx={{ position: "absolute", top: 10, left: "35%" }}>
							<SabiasQue
								icono={sabiasQueSanphet[0]?.icono ?? "👑"}
								texto={sabiasQueSanphet[0]?.texto ?? ""}
							/>
						</Box>
						{sabiasQueSanphet[1] && (
							<Box sx={{ position: "absolute", top: 52, left: "35%" }}>
								<SabiasQue
									icono={sabiasQueSanphet[1]?.icono ?? "🛕"}
									texto={sabiasQueSanphet[1]?.texto ?? ""}
								/>
							</Box>
						)}
					</>
				)}
				{watSanphetImage && (
					<Box
						component="img"
						src={watSanphetImage}
						alt=""
						sx={{
							width: "40%",
							height: 100,
							objectFit: "cover",
							borderRadius: "12px",
						}}
					/>
				)}
				<Box sx={{ width: "60%" }}>
					<Box component="h3" sx={h3}>
						{watSanphetTitle}
					</Box>
					{watSanphetBody && (
						<Box component="p" sx={p}>
							{watSanphetBody}
						</Box>
					)}
				</Box>
			</Box>

			<Box
				data-block-id="text-4"
				sx={{
					display: "flex",
					gap: 2,
					padding: "0 12px",
					marginBottom: 1.75,
					position: "relative",
					paddingBottom: isSmallScreen ? 2 : 0,
				}}
			>
				{sabiasQueMahathat.length > 0 && (
					<>
						<Box sx={{ position: "absolute", top: 10, left: "35%" }}>
							<SabiasQue
								icono={sabiasQueMahathat[0]?.icono ?? "🌳"}
								texto={sabiasQueMahathat[0]?.texto ?? ""}
							/>
						</Box>
						{sabiasQueMahathat[1] && (
							<Box sx={{ position: "absolute", top: 52, left: "35%" }}>
								<SabiasQue
									icono={sabiasQueMahathat[1]?.icono ?? "⚔️"}
									texto={sabiasQueMahathat[1]?.texto ?? ""}
								/>
							</Box>
						)}
					</>
				)}
				{watMahathatImage && (
					<Box
						component="img"
						src={watMahathatImage}
						alt=""
						sx={{
							width: "40%",
							height: 100,
							objectFit: "cover",
							borderRadius: "12px",
						}}
					/>
				)}
				<Box sx={{ width: "60%" }}>
					<Box component="h3" sx={h3}>
						{watMahathatTitle}
					</Box>
					{watMahathatBody && (
						<Box component="p" sx={p}>
							{watMahathatBody}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template200.thumbnail = "/images/template-1.png";
export default Template200;
